export enum SchoolDayOffer {
    NONE = 'keins',
    BOUND = 'gebunden',
    OPEN = 'offen'
}